import { FunctionComponent } from 'react';
import { Flex, BodyText, Gutter } from '@gaiads/telia-react-component-library';
import { LocalBundleEnvelope, LocalProduct } from '@cdaas/api-clients/dist/product-service-openapi';

interface AddonProductProps {
  bundle: LocalBundleEnvelope;
  addon: LocalProduct;
  index: number;
}

export const AddonProduct: FunctionComponent<AddonProductProps> = ({ bundle, addon, index }) => {
  const rightAddon = bundle.bundle.items.find(item => item.options[0].product_id === addon.id)!;
  return (
    <>
      <Flex centeredVertically>
        <BodyText margin={{ left: 'xs' }}>{addon.name ?? ''}</BodyText>
      </Flex>

      <Flex centeredVertically spaceBetween>
        <BodyText margin={{ left: 'xs' }} size={'xs'} color={'gray500'}>
          {rightAddon.options[0].sku}
        </BodyText>
      </Flex>
      {index !== bundle.addon_products!.length - 1 && <Gutter />}
    </>
  );
};
